<template lang="pug">
.login-form
  .login-form-header
    h2
      span.primary-text Sign In
  form(@submit.prevent="submit")

    AlertBox(v-if="error", type="danger", :text="error")

    div.form-field(:class="{error: $v.form.email.$error, 'error-required': !$v.form.email.required}")
      label
        input(v-model="$v.form.email.$model", type="email", placeholder="Email Address")
    div.form-field(:class="{error: $v.form.password.$error, 'error-required': !$v.form.password.required}")
      label
        input(v-model="$v.form.password.$model", type="password", placeholder="Password")
    div.form-field
      .row.apart.center
        .col
          button.button.primary-button(type="submit") Login
        .col
          router-link(:to="{name: 'ForgotPassword'}") Forgot Password

  p.footer
    | Don't have an account?
    a(@click="signUp") Sign up!
</template>

<script>

import { required } from 'vuelidate/lib/validators'

export default {
  name: 'LoginForm',
  components: {
  },
  props: {
  },
  data () {
    return {
      form: {
        email: '',
        password: ''
      },
      error: null
    }
  },
  validations: {
    form: {
      email: {
        required
      },
      password: {
        required
      }
    }
  },
  methods: {
    signUp () {
      this.$emit('swap', 'RegisterForm')
    },
    submit () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        console.log('invalid')
      } else {
        this.$store.dispatch('user/login', this.form).then(({company, showOnboarding}) => {
          console.log(company)
          if (company.isMember) {
            if (showOnboarding) {
              this.$router.push({name: 'OnboardingWelcome'}).catch(err => {})
              console.log('goto Onboarding')
            }
            else {
              this.$router.push({name: 'AdminDashboard'}).catch(err => {})
              console.log('goto AdminDashboard')
            }
          }
          this.$emit('close')
        }, error => {
          this.error = error.error
        })

      }
    },
    doGoogle(){
      const height = 600
      const width = 500
      const left = (window.screen.width / 2) - ((width / 2) + 10)
      const top = (window.screen.height / 2) - ((height / 2) + 50)

      const params = 'status=no,height=' + height + ',width=' + width + ',resizable=yes,left=' +
      left + ',top=' + top + ',screenX=' + left + ',screenY=' +
      top + ',toolbar=no,menubar=no,scrollbars=no,location=no,directories=no'

      const popup = window.open(
        '/oauth/loading/google',
        'GooglePopup',
        params
      )
    }
  },
  created () {
    this.oAuthListener = (msg) => {

      const authSuccess = (msg.data === 'auth_success')
      const authError = (msg.data.data && msg.data.data === 'auth_failure')

      if (authSuccess && trustedOrigin) {
        this.$router.push({ name: 'Dashboard' }).catch(err => {})
      }

      if (authError) {
        console.log(msg.data.errorMsg)
      }
    }

    window.addEventListener('message', this.oAuthListener)

    this.$once("hook:destroyed", () => {
      console.log('hook:destroy')
      window.removeEventListener('message', this.oAuthListener)
    })
  }
}
</script>

<style scoped lang="stylus">
  .login-form
    padding $spacing-3
    min-width 400px
    +for_breakpoint(mobile)
      min-width auto
    .login-form-header
      margin-bottom $spacing-3

    p.footer
      text-align center
      a
        cursor pointer
        margin-left 5px
        text-decoration underline

</style>
